module.exports = __webpack_public_path__ + "static/media/CJ_Header_Logo.4ed6b93b.png";